import { render } from "./TheTeam.vue?vue&type=template&id=b2c82dc0&scoped=true"
import script from "./TheTeam.vue?vue&type=script&lang=js"
export * from "./TheTeam.vue?vue&type=script&lang=js"

import "./TheTeam.vue?vue&type=style&index=0&id=b2c82dc0&scoped=true&lang=css"

import exportComponent from "/builds/appmart-development-team/appmart-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2c82dc0"]])

export default __exports__